export enum Role {
  Admin = 1,
  Cashier = 2,
  ForecourtAttendant = 3,
  BackOffice = 4,
}
